"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAugustWithKey = fetchAugustWithKey;
exports.fetchAugustWithBearer = fetchAugustWithBearer;
const constants_1 = require("./constants");
function fetchAugustWithKey(apiKey, relativeUrl, options) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const defaultHeaders = {
            'x-api-key': apiKey,
            'content-type': 'application/json',
            accept: 'application/json',
        };
        return yield fetch(`${constants_1.WEBSERVER_URL[((_a = options === null || options === void 0 ? void 0 : options.server) !== null && _a !== void 0 ? _a : 'production')]}${relativeUrl}`, {
            headers: Object.assign(Object.assign({}, defaultHeaders), options === null || options === void 0 ? void 0 : options.headers),
            method: (_b = options === null || options === void 0 ? void 0 : options.method) !== null && _b !== void 0 ? _b : 'GET',
            body: JSON.stringify(options === null || options === void 0 ? void 0 : options.data),
        });
    });
}
function fetchAugustWithBearer(bearerToken, relativeUrl, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const defaultHeaders = {
            authorization: `Bearer ${bearerToken}`,
            'content-type': 'application/json',
            accept: 'application/json',
        };
        return fetch(`${constants_1.WEBSERVER_URL}${relativeUrl}`, {
            headers: Object.assign(Object.assign({}, defaultHeaders), options.headers),
            method: options.method,
            body: JSON.stringify(options.data),
        });
    });
}
//# sourceMappingURL=fetcher.js.map